export default __webpack_public_path__ + "static/media/panos-nl.d34cb010.png";